import type { InputFile } from '@shared/components/uploader/interfaces/files.interface';
import { REPLACE_ZIP_PAC_EXTENSION } from '@shared/constants/regexp.constants';
import type { CreateAssetCreationRequestInput } from '@graphql/default/types';

export const mapCurrentChunkFile = (
  file: InputFile,
): CreateAssetCreationRequestInput => {
  const startChunkByteInFile = (file.chunkNumber - 1) * file.chunkSize;
  const endChunkByteInFile = Math.min(
    startChunkByteInFile + file.chunkSize,
    file.file.size,
  );
  const chunk = file.file.slice(startChunkByteInFile, endChunkByteInFile);

  return {
    id: file.uploadId,
    title: file.name.replaceAll(REPLACE_ZIP_PAC_EXTENSION, ''),
    chunkNumber: file.chunkNumber,
    totalChunks: file.totalChunks,
    file: chunk,
  };
};
